import React, { useState, useContext, useEffect, Suspense } from 'react';
import loadable from "@loadable/component";

//Components
import { ThemeContext } from "../../../context/ThemeContext";
import InvoiceCard from '../Dompet/Home/InvoiceCard';
import CardBlog from '../Dompet/Home/CardBlog';
import AdminServices from '../../../services/AdminServices';
import POPendingSummaryCard from "./POPendingSummaryCard";
import MRVPendingSummaryCard from "./MRVPendingSummaryCard";
import RequisitionPendingSummaryCard from "./RequisitionPendingSummaryCard";
import RepairPOPendingSummaryCard from "./RepairPOPendingSummaryCard";
import PhysicalBillTrackingCard from './PhysicalBillTrackingCard';
import PaymentPendingSummaryCard from "./PaymentPendingSummaryCard";

const RequestDataModal = React.lazy(() => import('./RequestDataModal'));
const POPendingModal = React.lazy(() => import('./POPendingModal'));
const PaymentActionDashboardModal = React.lazy(() => import('./PaymentActionDashboardModal'));
const PaymentActionBillingModal = React.lazy(() => import('./PaymentActionBillingModal'));
const MaterialReceivingDashboardModal = React.lazy(() => import('./MaterialReceivingDashboardModal'));
const PWOPendingModal = React.lazy(() => import("./RWOPendingModal"));
const PhysicalBillTrackingDashboard = React.lazy(() =>
  import('./PhysicalBillTrackingDashboard')
);
const AccountsDashboardModal = React.lazy(() =>
  import('./AccountsDashboardModal')
);

let isPreloaded = false;
const preloadRequestModal = () => {
  if (!isPreloaded) {
    import('./RequestDataModal');
    isPreloaded = true;
  }
};

//Graphs
const ActivityApexBarGraph = loadable(() =>
  import("../Dompet/Home/ActivityApexBarGraph")
);
const MRVActivityApexBarGraph = loadable(() =>
  import("../Dompet/Home/mrvActivityApexGraph")
);
const TransferApexGraph = loadable(() =>
  import("../Dompet/Home/TransferApexGraph")
);
const MivActivityGraph = loadable(() =>
  import("../Dompet/Home/MivActivtyGraph")
);
const MtnActivityGraph = loadable(() =>
  import("../Dompet/Home/MtnActivityGraph")
);

const Home2 = () => {

  const [showModal, setShowModal] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [modalType, setModalType] = useState(null);


  const user = JSON.parse(localStorage.getItem('userDetails'));
  const role = user?.data?.user?.role || null;


  const { changeBackground,
    changeSideBarStyle,
    changePrimaryColor,
    chnageSidebarColor,
  } = useContext(ThemeContext);

  const handleOpenModal = (type) => {

    switch (type) {
case "payment":

  if (
    role === "billing" ||
    role === "pomaker" ||
    role === "pochecker"
  ) {

    // Billing + PO Team use SAME payment module
    setModalType("billingPayment");

  } else if (role === "accounts") {

    setModalType("accountsPayment");

  } else {

    // Director / HO
    setModalType("payment");

  }

  break;

      case "mrv":

        setModalType("mrv");

        break;

      case "pwo":
        setModalType("pwo");
        break;

      default:

        setModalType(type);

    }

    setShowModal(true);

  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });

    if (window.innerWidth >= 768) {
      changeSideBarStyle({ value: "full", label: "full" });
    }

    changePrimaryColor("color_1");
    chnageSidebarColor("color_1");

    AdminServices.dashboard()
      .then(res => {
        setDashboardData(res?.data || {});
      })
      .catch(err => {
        console.log(err);
      });

  }, []);

  return (
    <>

      {/* ================================ */}
      {/* REQUISITION PENDING SUMMARY */}
      {/* ================================ */}

      <div className="row">

        <div className="col-12">

          <RequisitionPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />

        </div>

      </div>
      {/* ================================ */}
      {/* PO PENDING SUMMARY */}
      {/* ================================ */}

      <div className="row">
        <div className="col-12">
          <POPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* ================================ */}
      {/* REPAIR PO PENDING SUMMARY */}
      {/* ================================ */}

      <div className="row">

        <div className="col-12">

          <RepairPOPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />

        </div>

      </div>


      {/* ================================ */}
      {/* MATERIAL RECEIVING SUMMARY */}
      {/* ================================ */}

      <div className="row">
        <div className="col-12">
          <MRVPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>
      {/* ================================ */}
      {/* MATERIAL RECEIVING SUMMARY */}
      {/* ================================ */}

      <div className="row">
        <div className="col-12">
          <PhysicalBillTrackingCard
            data={dashboardData}
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* ================================ */}
      {/* PAYMENT PENDING SUMMARY */}
      {/* ================================ */}

      <div className="row">
        <div className="col-12">

          <PaymentPendingSummaryCard
            data={dashboardData}
            onClick={handleOpenModal}
          />

        </div>
      </div>


      {/* ================================ */}
      {/* EXISTING DASHBOARD */}
      {/* ================================ */}
      <div className="row invoice-card-row">
        <InvoiceCard
          data={dashboardData}
          onPendingClick={handleOpenModal}
          onMouseEnter={preloadRequestModal}
        />
      </div>

      {/* ================= ROW 1 ================= */}
      <div className="row">

        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Requisition Voucher StoreWise -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmitted}
                </span>
              </h4>
            </div>
            <div className="card-body pt-3">
              <ActivityApexBarGraph
                storeWiseCounts={dashboardData?.storeWiseCounts}
              />
            </div>
          </div>
        </div>



        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Transfer Orders -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedTransfer}
                </span>
              </h4>
            </div>
            <div className="card-body pt-3">
              <TransferApexGraph
                storeWiseCounts={dashboardData?.TranferStoreEiseCounts}
              />
            </div>
          </div>
        </div>

      </div>

      {/* ================= ROW 2 ================= */}
      <div className="row">
        <div className="col-xl-6 col-xxl-12">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Receipt Voucher -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedMrv}
                </span>
              </h4>
            </div>
            <div className="card-body pt-3">
              <MRVActivityApexBarGraph
                storeWiseCounts={dashboardData?.mrvStoreEiseCounts}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ================= ROW 3 ================= */}
      <div className="row">

        <div className="col-xl-3 col-xxl-6">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Issue Voucher -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.totalSubmittedMiv}
                </span>
              </h4>
            </div>
            <div className="card-body pt-3">
              <MivActivityGraph
                storeWiseCounts={dashboardData?.MivStoreWise}
              />
            </div>
          </div>
        </div>

        <div className="col-xl-9 col-xxl-12">
          <div className="card">
            <div className="card-header pb-0 border-0">
              <h4 className="card-title mt-2">
                Pending Material Transfer Note -
                <span className="badge bg-orange ms-1">
                  {dashboardData?.approvedMtn}
                </span>
              </h4>
            </div>
            <div className="card-body pt-3">
              <MtnActivityGraph
                storeWiseCounts={dashboardData?.MtnStoreWise}
              />
            </div>
          </div>
        </div>

      </div>

      {/* ================= ROW 4 (FIXED) ================= */}
      <div className="row">
        <div className="col-xl-6 col-xxl-12">
          <CardBlog
            totalRequestCompleted={dashboardData?.totalRequestcompleted}
            totalMivCompleted={dashboardData?.totalMIVcompleted}
            totalTransferCompleted={dashboardData?.totalTransfercompleted}
            totalMtncompleted={dashboardData?.totalMtncompleted}
            totalMrvcompleted={dashboardData?.totalMrvcompleted}
            requestTotal={dashboardData?.requestTotal}
            transferTotal={dashboardData?.transferTotal}
            mivTotal={dashboardData?.mivTotal}
            MtnTotal={dashboardData?.MtnTotal}
            MrvTotal={dashboardData?.MrvTotal}
          />
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <Suspense fallback={null}>

          {modalType === "request" && (
            <RequestDataModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "po" && (
            <POPendingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {modalType === "payment" && (
            <PaymentActionDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              userRole={role}
            />
          )}

          {modalType === "billingPayment" && (
            <PaymentActionBillingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}
          {modalType === "accountsPayment" && (
            <AccountsDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              userRole={role}
            />
          )}

          {modalType === "mrv" && (
            <MaterialReceivingDashboardModal
              show={showModal}
              handleClose={handleCloseModal}
              stores={dashboardData?.stores}
              userRole={role}
              totalPO={dashboardData?.totalPendingPOReceiving || 0}
              totalLocal={dashboardData?.totalPendingLocalReceiving || 0}

            />
          )}

          {modalType === "pwo" && (
            <PWOPendingModal
              show={showModal}
              handleClose={handleCloseModal}
            />
          )}

          {/* PHYSICAL BILL DASHBOARD */}
          {modalType === "physicalBill" && (
            <PhysicalBillTrackingDashboard
              show={showModal}
              handleClose={handleCloseModal}
              stores={dashboardData?.stores}
              userRole={role}
            />
          )}

        </Suspense>
      )}
    </>
  );
};

export default Home2;